import { getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStripePayments } from '@stripe/firestore-stripe-payments';
import { loadStripe } from '@stripe/stripe-js';

// Stripe Publishable Key - Live environment
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51R9OOn017cURwhxfvrWLQSYwgkiQrzm2COSlqFq7k0VvDor3QFLVsmR5mXVfa7QhnuQTjbTvSJW7JQ2G1Qnw1Xpc00ra2NnBbA';

// Stripe Price IDs - Fixed system identifiers
export const STRIPE_PRICE_IDS = {
  PRO_MONTHLY: 'price_1RK5lp017cURwhxfJGjYrB1R',      // Pro monthly plan price ID (for 'pro' type)
  PRO_YEARLY: 'price_1RK5lp017cURwhxfhMOhVIV5',       // Pro yearly plan price ID (for 'pro' type)
  BUSINESS_MONTHLY: 'price_1RK5ll017cURwhxfIes6lt2d', // Business monthly plan price ID
  BUSINESS_YEARLY: 'price_1RK5ll017cURwhxfCgSyDeOf',  // Business yearly plan price ID
  TRANSFER_ONETIME: 'price_1RK5zC017cURwhxfbCiHlo9Q'  // Transfer one-time price ID
};

// Stripe Product IDs
export const STRIPE_PRODUCT_IDS = {
  PRO: 'prod_SEYteyqC9vHd7L',       // Pro product ID (used for 'pro' type)
  BUSINESS: 'prod_SEYtcdAtObaJJE',  // Business product ID
  TRANSFER: 'prod_SEZ78N8k40W8tQ'   // Transfer product ID
};

// Function to initialize Stripe Payments
export const loadStripePayments = () => {
  const app = getApp();
  const db = getFirestore(app);
  
  // Initialize Stripe Payments with Firebase
  const payments = getStripePayments(app, {
    productsCollection: 'products',
    customersCollection: 'customers',
    checkoutSessionsCollection: 'checkout_sessions',
  });
  
  return payments;
};

// Get Stripe instance
export const getStripe = async () => {
  console.log('Initializing Stripe with key:', STRIPE_PUBLISHABLE_KEY.substring(0, 10) + '...');
  try {
    const stripeInstance = await loadStripe(STRIPE_PUBLISHABLE_KEY);
    if (stripeInstance) {
      console.log('Stripe initialized successfully');
    } else {
      console.error('Stripe initialization returned empty/null instance');
    }
    return stripeInstance;
  } catch (error) {
    console.error('Error initializing Stripe:', error);
    throw error;
  }
}; 